import React from "react";
import { useNavigate } from "react-router-dom"
import { useAuth } from "../signin/authcontext.jsx"
import { signOut } from "firebase/auth";
import { auth } from '../../firebase.js';  // Import the auth reference

function NavBar({ WebPages }) {
    const nav = useNavigate()
    const { user } = useAuth();

    const transition = {
        transition: ".3s"
    }
    const handleSignOut = async () => {
        try {
          await signOut(auth);
    
          window.location.href = "/";
        } catch (error) {
          console.error("Error signing out: ", error);
        }
    }
    const navButtonClass = "bg-transparent border-0 cursor-pointer rounded-lg p-2 text-xl delay-7 text-white hover:text-red-800 hover:bg-white"
    const WebPagesItems = WebPages.map(pagetitle =>
        <button type="button" key={pagetitle[1]} style={transition} className={navButtonClass}
            onClick={() => nav(pagetitle[1])}>
            {pagetitle[0]}
        </button>)
    if(user){
        WebPagesItems.push(<button type="button" key="dashboard" style={transition} className={navButtonClass}
            onClick={() => nav("/dashboard")}>
            {"Dashboard"}
        </button>
        )
        WebPagesItems.push(<button type="button" key="sign-out" style={transition} className={navButtonClass}
            onClick={() => handleSignOut()}>
            {"Sign Out"}
        </button>
        )
    }
    return (
        <div className="z-50 fixed bg-red-500 w-screen p-4 pl-5 shadow-md">
            <div className="flex gap-4 w-full">
                <div className="flex flex-row items-center">
                    <p className="text-white text-2xl justify-left pr-5">Vihas Veggalam</p>
                    <p className="text-white text-xl justify-left">Electrical and Computer Engineering Honors at UT</p>                    </div>
                <div className="flex flex-row items-center justify-end w-3/4 gap-10 pr-6" >
                    {WebPagesItems}
                </div>

            </div>
        </div>
    );
}
export default NavBar;